import { useUserProfile } from "@src/components/user/user-context";
import config from "@src/config";
import { useEffect } from "react";

type GAWindow = Window & {
	gtag?: (
		command: "config" | "set",
		targetOrParams: string | Record<string, unknown>,
		params?: Record<string, unknown>,
	) => void;
};

export function useGAIdentification() {
	const {
		user: [user],
	} = useUserProfile();

	useEffect(() => {
		const gaWindow = window as GAWindow;

		if (!config.googleAnalyticsId || !user || !gaWindow.gtag) return;

		gaWindow.gtag("config", config.googleAnalyticsId, {
			user_id: user.id,
		});
		gaWindow.gtag("set", "user_properties", {
			email: user.email,
			name: user.displayName,
			display_name: user.displayName,
			first_name: user.firstName,
			last_name: user.lastName,
		});
	}, [user]);
}
